// src/components/home/ComparisonSection.js
import React from 'react';
import './ComparisonSection.css';

const ComparisonSection = () => {
  const features = [
    {
      feature: "Sync Speed",
      nexhealth: "2-5 minutes delay",
      weave: "2-5 minutes delay",
      bookdentist: "Instant (real-time API)"
    },
    {
      feature: "Software Installation",
      nexhealth: "Yes (on your server)",
      weave: "Yes (on your server)",
      bookdentist: "None"
    },
    {
      feature: "Chrome Extensions",
      nexhealth: "Yes (on every computer)",
      weave: "Yes (on every computer)",
      bookdentist: "None"
    },
    {
      feature: "Double Booking Risk",
      nexhealth: "High (during sync delay)",
      weave: "High (during sync delay)",
      bookdentist: "Zero"
    },
    {
      feature: "Planned Appointments",
      nexhealth: "Not supported",
      weave: "Not supported",
      bookdentist: "Full support"
    },
    {
      feature: "IT Support Needed",
      nexhealth: "Yes (ongoing)",
      weave: "Yes (ongoing)",
      bookdentist: "None"
    },
    {
      feature: "Monthly Cost",
      nexhealth: "$400-600+",
      weave: "$500-800+",
      bookdentist: "$197"
    },
    {
      feature: "Setup Time",
      nexhealth: "2-4 weeks",
      weave: "2-4 weeks",
      bookdentist: "Same day"
    }
  ];

  return (
    <section className="comparison-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-badge">Side-by-Side Comparison</span>
          <h2 className="section-title">How BookDentist.pro Stacks Up</h2>
          <p className="section-subtitle">
            We're not the only option—but we're the only one that syncs instantly and requires zero IT support.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="comparison-table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th className="feature-column">Feature</th>
                <th className="competitor-column">
                  <div className="competitor-header">
                    <div className="competitor-logo">NexHealth</div>
                    <div className="competitor-note">Industry Standard</div>
                  </div>
                </th>
                <th className="competitor-column">
                  <div className="competitor-header">
                    <div className="competitor-logo">Weave</div>
                    <div className="competitor-note">Popular Choice</div>
                  </div>
                </th>
                <th className="bookdentist-column">
                  <div className="bookdentist-header">
                    <div className="bookdentist-logo">BookDentist.pro</div>
                    <div className="bookdentist-badge">✓ Recommended</div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {features.map((row, idx) => (
                <tr key={idx}>
                  <td className="feature-cell">{row.feature}</td>
                  <td className="competitor-cell">
                    <span className={row.nexhealth.includes('Yes') || row.nexhealth.includes('High') ? 'negative-value' : ''}>
                      {row.nexhealth}
                    </span>
                  </td>
                  <td className="competitor-cell">
                    <span className={row.weave.includes('Yes') || row.weave.includes('High') ? 'negative-value' : ''}>
                      {row.weave}
                    </span>
                  </td>
                  <td className="bookdentist-cell">
                    <span className={row.bookdentist.includes('None') || row.bookdentist.includes('Zero') || row.bookdentist.includes('Instant') || row.bookdentist.includes('Full') ? 'positive-value' : ''}>
                      {row.bookdentist}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Bottom Cards */}
        <div className="comparison-cards">
          <div className="comparison-card">
            <div className="card-icon">💰</div>
            <div className="card-title">Save $3,000+ Annually</div>
            <div className="card-text">
              At $197/month, you'll save over $3,000/year compared to NexHealth or Weave—while getting better technology.
            </div>
          </div>

          <div className="comparison-card">
            <div className="card-icon">⚡</div>
            <div className="card-title">Zero IT Headaches</div>
            <div className="card-text">
              No server software. No Chrome extensions on every computer. No IT person needed. Just log in and you're done.
            </div>
          </div>

          <div className="comparison-card">
            <div className="card-icon">🎯</div>
            <div className="card-title">Built for Open Dental</div>
            <div className="card-text">
              We only do Open Dental. That means our integration is deeper, faster, and more reliable than competitors who support 50+ systems.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;